import { ComponentType } from 'react'

export interface LoadFnResult<TProps> {
  default: ComponentType<TProps>
}

export type LoadFn<TProps = any> = () => Promise<LoadFnResult<TProps>>

export function retryWithoutFallback<TProps>(
  fn: LoadFn<TProps>,
  retriesLeft = 10,
  interval = 500,
): Promise<LoadFnResult<TProps>> {
  return new Promise<LoadFnResult<TProps>>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error)
            return
          }

          retryWithoutFallback(fn, retriesLeft - 1, interval).then(
            resolve,
            reject,
          )
        }, interval)
      })
  })
}
